import { useEffect, useState } from "react";
import { Save, Radio, CheckCircle2, Send } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { http, errMsg } from "@/lib/api";

export default function ChannelSettings() {
  const [channel, setChannel] = useState("");
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);

  const [detected, setDetected] = useState([]);
  useEffect(() => {
    http.get("/settings").then((r) => { setS(r.data); setChannel(r.data.channel_id || ""); });
    http.get("/telegram/detected-channels").then((r) => setDetected(r.data));
  }, []);

  const save = async (e, value) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const r = await http.put("/settings", { channel_id: value ?? channel });
      setS(r.data);
      setChannel(r.data.channel_id || "");
      toast.success(r.data.channel_id ? `Canale "${r.data.channel_title}" collegato` : "Canale scollegato");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  const toggleMirror = async (v) => {
    const r = await http.put("/settings", { mirror_channel: v });
    setS(r.data);
    toast.success(v ? "Tutto verrà pubblicato anche sul canale" : "Pubblicazione automatica sul canale disattivata");
  };
  const test = async () => {
    try { await http.post("/telegram/channel-test"); toast.success("Messaggio di prova pubblicato sul canale"); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <form data-testid="telegram-settings-form" onSubmit={save} className="panel p-6 space-y-4">
      <h3 className="font-display text-2xl font-bold uppercase flex items-center gap-2"><Radio size={20} className="text-[var(--tg)]" /> Canale Telegram</h3>
      {s?.channel_id ? (
        <div data-testid="channel-connected" className="flex items-center gap-2 text-sm text-[var(--win)]"><CheckCircle2 size={16} /> Collegato: <b>{s.channel_title || s.channel_id}</b> <span className="font-mono text-slate-500">{s.channel_id}</span></div>
      ) : (
        <p className="text-sm text-slate-400">1) Aggiungi il bot come <b>amministratore</b> del canale (permesso "Pubblica messaggi"). 2) Incolla qui @username o link del canale.</p>
      )}
      <input data-testid="telegram-channel-id-input" value={channel} onChange={(e) => setChannel(e.target.value)} placeholder="@mio_canale oppure https://t.me/mio_canale" className="w-full bg-slate-950 border border-slate-800 rounded-md px-3 py-2 font-mono text-sm focus:outline-none focus:border-[var(--gold)]" />
      <div className="flex flex-wrap gap-2">
        <button data-testid="save-telegram-settings-btn" disabled={busy} className="btn btn-gold"><Save size={16} /> {busy ? "Verifica..." : "Collega e verifica"}</button>
        {s?.channel_id && <button type="button" data-testid="channel-test-btn" onClick={test} className="btn btn-ghost"><Send size={16} /> Messaggio di prova</button>}
      </div>
      <div data-testid="detected-channels" className="pt-3 border-t border-slate-800 space-y-2">
        <div className="text-xs uppercase tracking-wider text-slate-400">Canali rilevati</div>
        {detected.length === 0 ? (
          <p className="text-xs text-slate-500">Canale privato? Aggiungi il bot come amministratore e pubblica un messaggio qualsiasi nel canale: comparirà qui (ricarica la pagina).</p>
        ) : detected.map((c) => (
          <div key={c.id} data-testid={`detected-channel-${c.id}`} className="flex items-center justify-between gap-3 text-sm">
            <span className="truncate">{c.title} <span className="font-mono text-xs text-slate-500">{c.username ? `@${c.username}` : c.id}</span>{c.status && c.status !== "administrator" && <span className="text-[var(--loss)] text-xs"> · bot non admin</span>}</span>
            <button type="button" data-testid={`use-channel-${c.id}`} disabled={busy || s?.channel_id === String(c.id)} onClick={() => save(null, String(c.id))} className="btn btn-ghost py-1 text-xs">{s?.channel_id === String(c.id) ? "In uso" : "Collega"}</button>
          </div>
        ))}
      </div>
      {s && (
        <div className="flex items-start justify-between gap-4 pt-3 border-t border-slate-800">
          <div>
            <div className="font-semibold text-sm">Pubblica tutto anche sul canale</div>
            <p className="text-xs text-slate-400">Pronostici, broadcast, risultati e riepiloghi inviati agli iscritti vengono pubblicati anche sul canale.</p>
          </div>
          <Switch data-testid="mirror-channel-switch" checked={!!s.mirror_channel} onCheckedChange={toggleMirror} />
        </div>
      )}
    </form>
  );
}
